<template>
  <div class="efficiency-report">
    <!-- 总数量对比 -->
    <div class="all-nums">
      <div class="search">
        <div class="title">日期：</div>
        <el-date-picker
          v-model="date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
        <el-button class="btn-blue" icon="el-icon-search" @click="search"
          >搜索</el-button
        >
      </div>
      <div class="all-nums-container">
        <div class="title">
          <span>24H各时间阶段各个仓库产量_总数量对比</span>
          <span>单位：件</span>
        </div>
        <div id="myChart" :style="{ width: '100%', height: '452px' }"></div>
      </div>
    </div>

    <!-- 24H各时间阶段混品/同品数量和总数量对比 -->
    <div class="contrast">
      <div class="search">
        <div class="title">仓库名称：</div>
        <el-select
          v-model="contrast.warehouseId"
          placeholder="请选择仓库"
          class="white"
        >
          <el-option
            v-for="item in warehouseList"
            :key="item.id"
            :label="item.name"
            :value="item.id"
          ></el-option>
        </el-select>
        <div class="title">日期：</div>
        <el-date-picker
          v-model="contrast.date"
          type="date"
          value-format="yyyy-MM-dd"
          placeholder="选择日期"
        ></el-date-picker>
        <el-button
          class="btn-blue"
          icon="el-icon-search"
          @click="searchContrast"
          >搜索</el-button
        >
        <el-button icon="el-icon-refresh" class="btn-gray" @click="resetForm"
          >重置</el-button
        >
      </div>
      <div class="contrast-container" style="height: 664px">
        <div class="contrast-container-left">
          <div
            class="team-row"
            :class="{ 'team-row-active': activeIndex == index }"
            v-for="(item, index) in teamList"
            :key="index"
            @click="selectTeam(item, index)"
          >
            <p class="team-name">班组名称：{{ item.name }}</p>
            <div class="nums-container">
              <div class="nums-half">
                订单数：
                <span class="team-nums">{{ item.nums }}</span
                >单
              </div>
              <div class="nums-half nums-half-right">
                商品数量：
                <span class="team-nums">{{ item.goodsQuantity }}</span
                >件
              </div>
            </div>
            <div class="nums-container">
              <div class="nums-half">
                单均时长：{{ item.hoursByUnitOrderNum }}
              </div>
              <div class="nums-half nums-half-right">
                件均时长：{{ item.hoursByUnitGoodsNum }}
              </div>
            </div>
          </div>
        </div>
        <div class="contrast-container-right">
          <div class="title">
            <span>24H各时间阶段各个仓库产量_总数量对比</span>
            <span class="sub-title">单位：件</span>
          </div>
          <div class="contrast-container-right-mian">
            <div
              id="myContrastChart"
              :style="{ width: '100%', height: '528px' }"
            ></div>
            <div
              id="myContrastChart2"
              :style="{ width: '100%', height: '528px' }"
            ></div>
            <img v-if="isShowNothing" class="nothing" src="../../../../assets/images/nothing/nothing.png">
          </div>
          <div class="contrast-container-right-foot">
            <div class="contrast-container-right-foot-content">
              <div class="row">
                <span class="origin-circle"></span>
                <span class="row-content">统计数量</span>
              </div>
              <div class="row">
                <span class="blue-circle"></span>
                <span class="row-content">混品件数</span>
              </div>
              <div class="row">
                <span class="green-circle"></span>
                <span class="row-content">同品件数</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Efficiency from "models/efficiency";
import warehouseMixins from "@/common/mixins/warehouse.js";
import { formatTimeToDate } from "common/js/util";
export default {
  mixins: [warehouseMixins],

  data() {
    return {
      date: this.timeDefault(),
      contrast: {
        date: this.timeDefault(),
        warehouseId: null,
      },
      activeIndex: 0,
      teamId: null,
      teamList: [],
      isShowNothing: true
    };
  },

  async created() {
    this.initWarehouse();
    setTimeout(() => {

      this.initAllQuantityComparison();
    },200)
    await this.initTeamList();
    await this.selectTeam(this.teamList[0], 0)
  },

  methods: {
    /**
     * @desc 获取总数量对比数据
     */
    initAllQuantityComparison() {
      let reportDate = this.date;
      let data = {
        reportDate,
      };
      Efficiency.getAllQuantityComparison(data).then(res => {
        if (res.success) {
          let legendArr = [];
          let arr = [];
          // 获取所有仓库
          let allWarehoseList = []
          res.result.map(i => {
            i.warehouseList.map(j => {
              allWarehoseList.push(j)
            })
          })
          allWarehoseList = this.unique(allWarehoseList)

          res.result.map((i) => {
            if (i.endHour == 8) legendArr.push(`0-${i.endHour}h`);
            if (i.endHour > 8) {
              legendArr.push(`${i.startHour}-${i.endHour}h`);
            }
            // if (i.endHour == 24) legendArr.push(`18-${i.endHour}h`);
            if (i.warehouseList.length) {
              allWarehoseList.map(j => {
                let obj = {};
                obj.data = [];
                obj.type = "bar";
                obj.endHour = i.endHour;
                obj.name = j.warehouseName;
                obj.warehouseId = j.warehouseId;
                let warehouseObj = i.warehouseList.find(item => { return item.warehouseId == j.warehouseId})
                if (warehouseObj) {
                  obj.num = warehouseObj.num 
                } else {
                  obj.num = 0;
                }
                arr.push(obj);
              });
            } else {
              allWarehoseList.map(j => {
                let obj = {};
                obj.data = [];
                obj.type = "bar";
                obj.endHour = i.endHour;
                obj.name = j.warehouseName;
                obj.warehouseId = j.warehouseId;
                obj.num = 0;
                arr.push(obj);
              })
            }
          });

          // 合并同类项
          arr = arr
            .map(function (item, index, arr) {
              const i = arr.find((_item) => item.name === _item.name);
              if (i !== item) {
                i.data.push(item.num);
                return undefined;
              } else {
                i.data = [i.num];
                return i;
              }
            })
            .filter((item) => item !== undefined);

          // 处理数据（前8个相加和后6个相加）
          arr.map((i) => {
            let array = [];
            let eightNum = 0;
            // let endSixNum = 0;
            i.data.map((j, index) => {
              if (index < 8) {
                eightNum += j;
              }
              if (index == 7) array.push(eightNum);
              if (index > 7) array.push(j);
              // if (index > 17) {
              //   endSixNum += j;
              // }
              // if (index == 23) array.push(endSixNum);
            });
            i.data = array;
          });
          this.allQuantityComparison(legendArr, arr);
        } else {
          this.$message.error(res.message);
        }
      })
    },
    
    /**
     * @desc 24H各时间阶段混品/同品数量和总数量对比
     */
    initTwentyFourContrast() {
      let reportDate = this.contrast.date;
      let teamGroupId = this.teamId
      let data = {
        reportDate,
        teamGroupId
      };
      Efficiency.getTwentyFourContrast(data).then(res => {
        if (res.success) {
          this.isShowNothing = res.result.length ? false : true
          let legendArr = [];
          // 混品件数列表
          let mixedProductsNumsArr = []
          // 同品件数列表
          let sameProductNumsArr = []
          // 统计数量列表
          let statisticalQuantityArr = []
          res.result.map((i) => {
            if (i.endHour == 8) legendArr.push(`0-${i.endHour}h`);
            if (i.endHour > 8) {
              legendArr.push(`${i.startHour}-${i.endHour}h`);
            }
            // if (i.endHour == 24) legendArr.push(`18-${i.endHour}h`);
            mixedProductsNumsArr.push(i.commonGoodsQuantity);
            sameProductNumsArr.push(i.hotGoodsQuantity);
            statisticalQuantityArr.push(i.num);
          });
          mixedProductsNumsArr = this.handleData(mixedProductsNumsArr)
          sameProductNumsArr = this.handleData(sameProductNumsArr)
          statisticalQuantityArr = this.handleData(statisticalQuantityArr)
          this.initMyContrastChart(legendArr.reverse(), mixedProductsNumsArr.reverse(), sameProductNumsArr.reverse());
          this.initMyContrastChart2(legendArr.reverse(), statisticalQuantityArr.reverse());
        } else {
          this.$message.error(res.message);
        }
      })
    },

    handleData(list) {
      let array = [];
      // 处理数据（前8个相加和后6个相加）
      let eightNum = 0;
      // let endSixNum = 0;
      list.map((i, index) => {
        if (index < 8) {
          eightNum += i;
        }
        if (index == 7) array.push(eightNum);
        if (index > 7) array.push(i);
        // if (index > 17) {
        //   endSixNum += i;
        // }
        // if (index == 23) array.push(endSixNum);
      });
      return array
    },

    /**
     * @desc 获取班组列表
     */
    async initTeamList() {
      let reportDate = this.contrast.date;
      let warehouseId = this.contrast.warehouseId;
      let data = {
        reportDate,
        warehouseId,
      };
      let res = await Efficiency.getTeamList(data)
      if (res.success) {
        let arr = [];
        res.result.map((i) => {
          let obj = {};
          obj.id = i.teamGroupId;
          obj.name = i.leaderName;
          obj.nums = i.num;
          obj.goodsQuantity = i.goodsQuantity;
          obj.hoursByUnitOrderNum = i.hoursByUnitOrderNum?i.hoursByUnitOrderNum:'--';
          obj.hoursByUnitGoodsNum = i.hoursByUnitGoodsNum?i.hoursByUnitGoodsNum:'--';
          arr.push(obj);
        });
        this.teamList = arr;
      } else {
        this.$message.error(res.message);
      }
    },
    
    timeDefault() {
      let date = new Date();
      const currentDay = formatTimeToDate(date.getTime())
      return currentDay;
    },
    
    /** 
     * @desc 去重(后面替换前面的)
    */
    unique(arr) {
      let res = []
      let map = new Map()
      for (let i of arr) {
        map.set(i.warehouseId, i)
      }
      res = [...map.values()]
      return res
    },

    /**
     * @desc 总数量对比
     */
    allQuantityComparison(legendArr, seriesArr) {
      let initEchart = this.$echarts.init(document.getElementById("myChart"));
      initEchart.setOption({
        legend: {
          bottom: "24px",
          itemWidth: 10,
          itemHeight: 10,
          textStyle: {
            padding: [2, 0, 0, 0],
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        grid: {
          top: "10px",
          left: "3%",
          right: "3%",
          containLabel: true,
        },
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "none",
          },
        },
        xAxis: {
          type: "category",
          data: legendArr,
        },
        yAxis: {},
        series: seriesArr,
      });
    },

    /**
     * @desc 搜索总数量对比
     */
    search() {
      this.initAllQuantityComparison();
    },

    /**
     * @desc 搜索24H各时间阶段混品/同品数量和总数量对比
     */
    async searchContrast() {
      await this.initTeamList()
      let index = this.teamList.findIndex(item => { return item.id === this.teamId})
      if (index !== -1) {
        await this.selectTeam(this.teamList[index], index)
      } else {
        await this.selectTeam(this.teamList[0], 0)
      }
    },

    resetForm() {
      this.contrast.date = this.timeDefault();
      this.contrast.warehouseId = null;
    },

    /**
     * @desc 选择班组
     */
    selectTeam(row, index) {
      this.activeIndex = index;
      this.teamId = row.id
      this.initTwentyFourContrast()
    },

    /**
     * @desc 24H各时间阶段混品/同品数量和总数量对比echarts初始化
     */
    initMyContrastChart(legendArr, mixedProductsNumsArr, sameProductNumsArr) {
      let initEchart = this.$echarts.init(
        document.getElementById("myContrastChart")
      );
      initEchart.setOption({
        tooltip: {
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: false,
          right: "32px",
          bottom: "16px",
          itemWidth: 10,
          itemHeight: 10,
          data: ["混品件数", "同品件数"],
          textStyle: {
            padding: [2, 0, 0, 0],
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        grid: {
          top: "0px",
          left: "24px",
          right: "0px",
          bottom: "0px",
          containLabel: true,
        },
        xAxis: [
          {
            type: "value",
            inverse: true,
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            }
          },
        ],
        yAxis: [
          {
            type: "category",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: legendArr,
          },
        ],
        series: [
          {
            name: "混品件数",
            type: "bar",
            // stack: "Total",
            label: {
              show: true,
              color: '#ffffff',
              position: 'insideLeft',
              fontSize: 11,
              offset: [0,1]
            },
            // 最小柱体高度
            barMinHeight: 24,
            itemStyle: {
              color: '#1890FF'
            },
            data: mixedProductsNumsArr,
            // 移动第二个柱子的位置实现重叠
            // barGap: '-100%',
            // // 改变这根柱子的层级使这根柱子在下面
            // z: '-1'
          },
          {
            name: "同品件数",
            type: "bar",
            // stack: "Total",
            label: {
              show: true,
              color: '#ffffff',
              position: 'insideLeft',
              fontSize: 11,
              offset: [0,1],
            },
            // 最小柱体高度
            barMinHeight: 24,
            itemStyle: {
              color: '#2FC25B',
            },
            data: sameProductNumsArr,
          },
        ],
      });
    },
    /**
     * @desc 24H各时间阶段统计数量对比echarts初始化
     */
    initMyContrastChart2(legendArr, statisticalQuantityArr) {
      let initEchart = this.$echarts.init(
        document.getElementById("myContrastChart2")
      );
      initEchart.setOption({
        tooltip: {
          show: false,
          trigger: "axis",
          axisPointer: {
            type: "shadow",
          },
        },
        legend: {
          show: false,
          right: "32px",
          bottom: "16px",
          itemWidth: 10,
          itemHeight: 10,
          data: ["统计数量"],
          textStyle: {
            padding: [2, 0, 0, 0],
            rich: {
              a: {
                verticalAlign: "middle",
              },
            },
          },
        },
        grid: {
          top: "0px",
          left: "-40px",
          right: "24px",
          bottom: "0px",
          containLabel: true,
        },
        xAxis: [
          {
            type: "value",
            splitLine: {
              show: false,
            },
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            axisLabel: {
              show: false,
            }
          },
        ],
        yAxis: [
          {
            show: false,
            type: "category",
            axisTick: {
              show: false,
            },
            axisLine: {
              show: false,
            },
            data: legendArr,
          },
        ],
        series: [
          {
            name: "统计数量",
            type: "bar",
            // stack: "Total",
            barWidth: 23,
            label: {
              show: true,
              color: '#ffffff',
              position: 'insideRight'
            },
            // 最小柱体高度
            barMinHeight: 24,
            itemStyle: {
              color: '#FACC14'
            },
            data: statisticalQuantityArr,
          },
        ],
      });
    },
  },
};
</script>

<style lang='scss'>
@import "@/assets/style/layout/home/efficiency-report.scss";
</style>
